import App from '../index.js';
import { findIndex, each, indexOf, isEmpty } from 'lodash';

App.UsersEdit = (function () {
    const template = $('<div/>').html($('#bot_checkbox_template').html()),
        subdomainFilterTemplate = $('<div/>').html($('#bot_subdomain_filter_template').html());
    const user_organization_id = $('.bots-list').data('user-organization-id');

    function displayBotsByOrganization (organization_id){
        const index = findIndex(window.organizations, function ( organization ) {
            return organization.id === organization_id;
        });
        const filteredOrganization = window.organizations[index];

        let botTemplates = [];

        each(filteredOrganization.bots, function ( bot, index ) {
            let botTemplate = template.clone();
            const elBotItem = botTemplate.find('.bot-item');
            const elInput = botTemplate.find('.bot-holder .form-check-input');
            elInput.attr('id', 'bots_' + index).val(bot.id);
            elInput.attr('name', 'allowed_bots[' + index + '][id]').val(bot.id);
            botTemplate.find('.bot-holder .form-check-label').text(bot.name).attr('for', 'bots_' + index);

            elBotItem.attr('data-id', index);
            const userBotIndex = findIndex(window.userBots, function ( userBot ) {
                return userBot.bot_id === bot.id;
            });

            if (userBotIndex > -1) {
                elInput.attr('checked', 'checked');
                elBotItem.find('.permissions-holder').removeClass('d-none');
            }

            const userBot = window.userBots?.[userBotIndex] || {};
            setupUserSpecificPermissions(userBot, elBotItem, index);
            setupUserSpecificSubsites(userBot, elBotItem, index);

            botTemplates.push(botTemplate.html());
        });

        $('.bots-list').html(botTemplates.join(''));
    }

    function setupUserSpecificPermissions ( userBot, elBotItem, elBotItemIndex ) {
        const allowedActions = userBot.allowed_actions || [];

        // If permissions is allowed mark as checked.
        elBotItem.find('.permissions-holder .form-check').each(function ( index, elItem ) {
            const elCheckInput = $(elItem).find('.form-check-input');
            elCheckInput.attr('id', 'bots_' + elBotItemIndex + '_permissions_' + index);
            elCheckInput.attr('name', 'allowed_bots[' + elBotItemIndex + '][permissions][]');
            $(elItem).find('.form-check-label').attr('for', 'bots_' + elBotItemIndex + '_permissions_' + index);

            if (allowedActions.includes(elCheckInput.val())) {
                elCheckInput.attr('checked', 'checked');
            }
        });
    }

    function setupUserSpecificSubsites( userBot, elBotItem, elBotItemIndex ) {
        let allowedSubsites = userBot.subsites || [];

        toggleSubdomainFilterList(elBotItem);

        // If we have initial subdomains clear the default empty input field.
        if(!isEmpty(allowedSubsites)) {
            elBotItem.find('.subdomains-list').html('');
        } else {
            // Default
            allowedSubsites.push('');
        }

        // Append the initial subsites
        $.each(allowedSubsites, function ( index, item ) {
            let subdomainFilterTemplateClone = subdomainFilterTemplate.clone();
            subdomainFilterTemplateClone.find('.subdomain-field').attr('value', item.subsite).attr('name', 'allowed_bots[' + elBotItemIndex + '][subsites][]');
            elBotItem.find('.subdomains-list').append(subdomainFilterTemplateClone.html());
        });
    }

    function userPermissionUpdate () {
        const elParent = $(this).closest('.permissions-holder');
        toggleSubdomainFilterList(elParent);
    }

    function toggleSubdomainFilterList (el) {
        const elSubdomainFilter = el.closest('.bot-item').find('.subdomain-filters');

        // If only view analytics is enabled, the subdomain filter should be displayed.
        const isShowSubdomainFilter = el.find('.allow-view-analytics').is(':checked') && !el.find('.allow-edit-bot').is(':checked');
        elSubdomainFilter.toggleClass('d-none', !isShowSubdomainFilter);
    }

    function selectBot () {
        const elParent = $(this).closest('.bot-item');
        elParent.find('.permissions-holder').toggleClass('d-none', !$(this).is(':checked'));
    }

    function addSubdomainRow () {
        const elList = $(this).closest('.subdomain-filters-wrapper');
        let subdomainFilterTemplateClone = subdomainFilterTemplate.clone();
        subdomainFilterTemplateClone.find('.subdomain-field').attr('name', 'allowed_bots[' + elList.closest('.bot-item').attr('data-id') + '][subsites][]');
        elList.find('.subdomains-list').append(subdomainFilterTemplateClone.html());
    }

    function removeSubdomainRow () {
        $(this).closest('.subdomain-item').remove();
    }

    function sendPasswordReset(e) {
        e.preventDefault();
        $($(this).attr('href'))[0].submit();
    }

    function onChangeRole() {
        const role = $(this).val(),
        elOrganizationOptions = $('#organization_options');

        elOrganizationOptions.toggleClass('d-none', role === 'admin');
    }

    return {
        init: function () {

            $('#bot_access_form [name="bots_access"]').on('change', function () {
                $('.bots-list').toggleClass('d-none', $(this).val() !== 'specific');
            });

            $('body').on('change', '.bots-list .bot-item .permissions-holder .form-check-input', userPermissionUpdate)
                .on('change', '.bots-list .bot-item .bot-holder .form-check-input', selectBot)
                .on('click', '.bots-list .bot-item .add-subdomain-filter', addSubdomainRow)
                .on('click', '.bots-list .bot-item .remove-subdomain:not(:disabled)', removeSubdomainRow)
                .on('click', '.send-password-reset', sendPasswordReset)
                .on('change', '#role', onChangeRole);
        }
    };

})();

// Provide the route name
App.registerRoute('users.edit', App.UsersEdit.init);
App.registerRoute('users.create', App.UsersEdit.init);

export default App.UsersEdit;
